module.exports = __webpack_public_path__ + "img/cafta.d009d8e4.jpeg";